import CopilotPreview from 'ai-addon-copilot-preview/components/CopilotPreview/CopilotPreview';
import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import { useCallback, useState } from 'react';
import { View } from 'foundations-components/transitional/components/View';
import { loadCSATSurvey } from '../utils/feedback';
import enviro from 'enviro';
import I18n from 'I18n';
import { CALL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
const CALL_SUMMARIZATION_SURVEY_ID = 1025;
const CopilotCallSummary = ({
  usageTracker,
  callId,
  usageTrackerAppLocationKey
}) => {
  const [renderCSATOnSubmit, setRenderCSATOnSubmit] = useState(true);
  const onPreviewShown = useCallback(() => {
    if (renderCSATOnSubmit) {
      setRenderCSATOnSubmit(false);
    }
  }, [renderCSATOnSubmit]);
  const onClick = useCallback(() => {
    if (renderCSATOnSubmit && enviro.isProd()) {
      loadCSATSurvey(CALL_SUMMARIZATION_SURVEY_ID);
    }
  }, [renderCSATOnSubmit]);
  return /*#__PURE__*/_jsx(CopilotProvider, {
    children: /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(CopilotPreview, {
        appName: "recording-review-ui",
        copilotAction: {
          intent: 'object_summary',
          context: {
            summary_location: 'COPILOT_PREVIEW'
          },
          objectId: `${callId}`,
          objectTypeId: CALL_TYPE_ID,
          objectTypeLabel: 'call',
          label: `with id ${callId}`
        },
        copilotActionButtonText: "Summarize this call",
        previewTitle: I18n.text('call-summary.notesTitle'),
        usageTracker: usageTracker,
        previewKey: `0-4fff:${callId}`,
        previewSource: "CALLING_SUMMARY",
        usageTrackerAppLocationKey: usageTrackerAppLocationKey || 'Call-Summary:Copilot-Call-Summary',
        onPreviewShown: onPreviewShown,
        onClick: onClick
      })
    })
  });
};
export default CopilotCallSummary;